"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulletinServiceImpl = void 0;
var BulletinProviderImpl_1 = require("./provider/firebase/BulletinProviderImpl");
var BulletinProviderImpl_2 = require("./provider/airabbi/BulletinProviderImpl");
var BulletinServiceImpl = (function () {
    function BulletinServiceImpl(cfg) {
        this.cfg = cfg;
        switch (cfg.provider) {
            case 'firebase':
                this.provider = new BulletinProviderImpl_1.BulletinProviderImpl(cfg);
                break;
            case 'airabbi':
                this.provider = new BulletinProviderImpl_2.BulletinProviderImpl(cfg);
                break;
        }
    }
    BulletinServiceImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        return this.provider.init(env);
    };
    BulletinServiceImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
        this.provider.setDebuggable(debuggable);
    };
    BulletinServiceImpl.prototype.getAllBulletin = function () {
        return this.provider.getAllBulletin();
    };
    BulletinServiceImpl.prototype.createBulletin = function (id, bulletin) {
        return this.provider.createBulletin(id, bulletin);
    };
    BulletinServiceImpl.prototype.updateBulletin = function (id, bulletin) {
        return this.provider.updateBulletin(id, bulletin);
    };
    BulletinServiceImpl.prototype.removeBulletin = function (id) {
        return this.provider.removeBulletin(id);
    };
    BulletinServiceImpl.prototype.getAvailableBulletin = function () {
        return this.provider.getAvailableBulletin();
    };
    BulletinServiceImpl.prototype.markAsRead = function (id) {
        return this.provider.markAsRead(id);
    };
    BulletinServiceImpl.prototype.stopAllMonitor = function () {
    };
    return BulletinServiceImpl;
}());
exports.BulletinServiceImpl = BulletinServiceImpl;
//# sourceMappingURL=BulletinServiceImpl.js.map